import { Category } from '@src/main/modules/parameters/domain/issues/category.interface';
import { createTypeHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/TypeHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDeleteType = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createTypeHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      await repository.delete(id);
      return id;
    },
    onSuccess: (deletedId) => {
      queryClient.invalidateQueries({ queryKey: ['types'] });
      queryClient.setQueryData<Category[]>(
        ['types'],
        (old) => old?.filter((cat) => cat.categoryId !== deletedId) ?? [],
      );
    },
  });
};
